<template>
  <div style="background-color: #fff;height: 700px;">
    <form>
		<h1 align="center">{{learn}}</h1><br>
    <h1 align="center">教学评价调查问卷</h1>
		<br>
    <h4>亲爱的同学：</h4><br>
    <h4>您好！本问卷的目的在于了解同学们对于本课程的教学建议和学习需求，以便进一步优化此项虚拟仿真实训课程。请您认真填好以下的问题，您的回答将为课程教学提供建设性信息。</h4><br>
    <h4>本问卷以不记名形式进行，我们将对所填内容保密，请您放心真实的填写！</h4><br>
    <fieldset>
    <el-form ref="form" :model="data" label-width="80px" style="margin-top: 20px;">
      <el-form-item>
        <span>{{topic1}}</span><br>
        <el-radio-group v-model="data.estimate" style="margin-top: 20px;">
          <el-radio v-for="(item,index) in option1" :key="index"   :label="index" >{{item}}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item style="margin-top: 20px;">
        <span>{{topic2}}</span><br>
        <el-checkbox-group v-model="data.know" style="margin-top: 20px;">
          <el-checkbox v-for="(item,index) in option2" :key="index" :label="index" name="type">{{item}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item style="margin-top: 20px;">
        <span>{{topic3}}</span><br>
         <el-input type="textarea" v-model="data.resource" style="margin-top: 20px;"></el-input>
      </el-form-item>
   <el-form-item style="margin-top: 20px;" >
     <span>{{topic4}}</span><br>
      <el-input type="textarea" v-model="data.perspective" style="margin-top: 20px;"></el-input>
   </el-form-item>
   <el-form-item  align="center" style="margin-top: 100px;" >
     <el-button type="primary" @click="onSubmit()" >提交问卷</el-button>
   </el-form-item>
 </el-form>
 </fieldset>
	</form>
  </div>
</template>
<script>
export default {
    name: "evaluate",
    data() {
      return {
        learn:'',
        topic1:'',
        topic2:'',
        topic3:'',
        topic4:'',
        option1:[],
        option2:[],
        data: {
          user_id: this.$store.getters.getUserInfo.id,
          learn_id:this.$route.query.id,
          estimate: '',
          know: [],
          resource: '',
          perspective: ''
        }
      }
    },
    mounted() {
        this.getlist()
    },
    methods: {
      getlist(){
       this.$http.getproblem({'learn_id':this.$route.query.id})
        .then(res => {
          this.learn=res.data.learn;
          this.topic1=res.data.problem[0].topic;
          this.topic2=res.data.problem[1].topic;
          this.topic3=res.data.problem[2].topic;
          this.topic4=res.data.problem[3].topic;
          this.option1=res.data.problem[0].option;
          this.option2=res.data.problem[1].option;
        })
        .catch(err => {
          // console.log(err);
        });
      },
      onSubmit() {
        if(this.data.estimate==''||this.data.resource==''||this.data.know==''||this.data.perspective==''){
          this.$message.error('还有题目未完成，请完成填写');
        }else{
            this.$http.addevaluate(this.data).then(res => {
                if (res.code !== 0) {
                   this.$message.success('谢谢您的参与！');
                    this.$router.back();
                }else {
                    this.$message.error(res.message)
                }
            })
        }
      },
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Course/Evaluate.vue